import styles from "./loader.module.scss";
export default function loader() {
  return (
    <div className={styles.loadingCtn}>
      <span className={styles.loader} />
    </div>
  );
}
